// Type imports:
import { IResponseLoginBody, ILoginError, ISystemProfileResponse, IResponseLoginSigtiBody } from '../api/LoginTypes';

// ========================= REQUEST LOGIN =========================
export const REQUEST_LOGIN_SUCCESS = 'REQUEST_LOGIN_SUCCESS';
export const REQUEST_LOGIN_FAILURE = 'REQUEST_LOGIN_FAILURE';
interface IRequestLoginSuccessAction {
    type: typeof REQUEST_LOGIN_SUCCESS,
    payload: IResponseLoginSigtiBody
}
interface IRequestLoginFailureAction {
    type: typeof REQUEST_LOGIN_FAILURE,
    payload: ILoginError
}

// ========================= REQUEST LOGOUT =========================
export const LOG_OUT = 'LOG_OUT';
export const REQUEST_LOGOUT_FAILURE = 'REQUEST_LOGOUT_FAILURE';

interface ILogOutAction {
    type: typeof LOG_OUT
}
interface IRequestLogoutFailureAction {
    type: typeof REQUEST_LOGOUT_FAILURE,
    payload: ILoginError
}

// ========================= REQUEST ACCESS TOKEN =========================
export const REQUEST_ACCESS_TOKEN_SUCCESS = 'REQUEST_ACCESS_TOKEN_SUCCESS';
export const REQUEST_ACCESS_TOKEN_FAILURE = 'REQUEST_ACCESS_TOKEN_FAILURE';
interface IRequestAccessTokenSuccessAction {
    type: typeof REQUEST_ACCESS_TOKEN_SUCCESS,
    payload: IResponseLoginBody
}

interface IRequestAccessTokenFailureAction {
    type: typeof REQUEST_ACCESS_TOKEN_FAILURE,
    payload: ILoginError
}

// ========================= LOG OUT =========================


/* REQUEST SYSTEM PROFILE */
export const REQUEST_SYSTEM_PROFILE_SUCCESS = 'REQUEST_SYSTEM_PROFILE_SUCCESS';
export const REQUEST_SYSTEM_PROFILE_FAILURE = 'REQUEST_SYSTEM_PROFILE_FAILURE';
interface IRequestSystemProfileSuccessAction {
    type: typeof REQUEST_SYSTEM_PROFILE_SUCCESS,
    payload: ISystemProfileResponse
}

interface IRequestSystemProfileFailureAction {
    type: typeof REQUEST_SYSTEM_PROFILE_FAILURE,
    payload: string
}

/* REQUEST USER INFO */
export const REQUEST_USER_INFO_SUCCESS = 'REQUEST_USER_INFO_SUCCESS';
export const REQUEST_USER_INFO_FAILURE = 'REQUEST_USER_INFO_FAILURE';
interface IRequestUserInfoSuccessAction {
    type: typeof REQUEST_USER_INFO_SUCCESS,
    payload: {
        userName: string,
        organization: string
    }
}

interface IRequestUserInfoFailureAction {
    type: typeof REQUEST_USER_INFO_FAILURE,
    payload: {
        error: string
    }
}

/* REQUEST EMS TOKEN */
export const REQUEST_EMS_TOKEN_SUCCESS = 'REQUEST_EMS_TOKEN_SUCCESS';
export const REQUEST_EMS_TOKEN_FAILURE = 'REQUEST_EMS_TOKEN_FAILURE';
interface IRequestEmsTokenSuccessAction {
    type: typeof REQUEST_EMS_TOKEN_SUCCESS,
    payload: IResponseLoginBody
}

interface IRequestEmsTokenFailureAction {
    type: typeof REQUEST_EMS_TOKEN_FAILURE,
    payload: string
}

/* SET USERNAME AND PASSWORD */
export const SET_USERNAME_AND_PASSWORD = 'SET_USERNAME_AND_PASSWORD';
interface ISetUsernameAndPasswordAction {
    type: typeof SET_USERNAME_AND_PASSWORD,
    payload: {
        username: string,
        password: string
    }
}

/* SYSTEM PROFILE FAILOVER */
export const SYSTEM_PROFILE_FAILOVER = 'SYSTEM_PROFILE_FAILOVER';
interface ISystemProfileFailoverAction {
    type: typeof SYSTEM_PROFILE_FAILOVER
}

/* START LOG OUT TIMER */
export const START_LOG_OUT_TIMER = 'START_LOG_OUT_TIMER';
interface IStartLogOutTimerAction {
    type: typeof START_LOG_OUT_TIMER
}

// ===================================== REQUEST_FORBIDDEN =====================================
export const REQUEST_FORBIDDEN= 'REQUEST_FORBIDDEN';
interface IRequestForbidenAction {
    type: typeof REQUEST_FORBIDDEN,
}

export type LoginActions =
IRequestAccessTokenSuccessAction
| IRequestLoginSuccessAction
| IRequestLoginFailureAction
| IRequestAccessTokenFailureAction
| ILogOutAction
| IRequestLogoutFailureAction
| IRequestSystemProfileSuccessAction
| IRequestSystemProfileFailureAction
| IRequestUserInfoSuccessAction
| IRequestUserInfoFailureAction
| IRequestEmsTokenSuccessAction
| IRequestEmsTokenFailureAction
| ISetUsernameAndPasswordAction
| ISystemProfileFailoverAction
| IStartLogOutTimerAction
| IRequestForbidenAction;